<template>
  <div class="content-container">
    <!-- <div class="top-control-container">
      <div class="navigator">
        <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
      </div>
      <div class="button-containers">
        <button class="btn primary medium">
          {{ $t('button.search') }}
        </button>
      </div>
    </div>

    <div class="">
      <div class="filter-collapse-btn">
        <el-button
          v-if="searchShow"
          icon="el-icon-arrow-up"
          size="mini"
          @click="searchShow = false"
          >{{ $t('searchBox.hideFilterBtn') }}</el-button
        >
        <el-button
          v-else
          icon="el-icon-arrow-down"
          size="mini"
          @click="searchShow = true"
          >{{ $t('config.profile.searchBox.showFilter') }}</el-button
        >
        <a
          v-if="searchShow"
          @click="
            searchParams = { ...defaultSearchParams }
            $emit('resetSearch')
          "
          >{{ $t('searchBox.resetFilterBtn') }}</a
        >
      </div>

      <el-collapse-transition>
        <div v-show="searchShow" class="filter_container">
          <div class="section-box">
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">
                        {{ 'Ngày' }}
                      </div>
                      <div class="child-w-80">
                        <CalendarSelect
                          v-model="searchParams.birthDay"
                          style="display: block; width: 100%"
                          mode="date"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></div
      ></el-collapse-transition>
    </div>

    <div v-loading="loading" class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :auto-size-cell="true"
        :columns="columns"
        :rows="rows"
        class="agGrid"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>

    <div class="button-containers mb-0">
      <button class="btn primary small">
        {{ 'Xuất excel' }}
      </button>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */

import paginationMixin from '@/mixins/paginationMixin'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'

import * as dayjs from 'dayjs'
import { getBirthDay } from '@/api/reception/reception'

export default {
  components: { CalendarSelect },
  mixins: [paginationMixin],
  data() {
    return {
      // search box
      searchShow: true,

      searchParams: {
        birthDay: dayjs().format('YYYY-MM-DD')
      },
      defaultSearchParams: {
        birthDay: dayjs().format('YYYY-MM-DD')
      },

      rows: [],
      loading: false
    }
  },

  computed: {
    columns() {
      return [
        {
          headerName: 'Xác nhận',
          field: ''
        },
        {
          headerName: 'Phòng',
          field: ''
        },
        {
          headerName: 'Danh xưng',
          field: ''
        },
        {
          headerName: 'Họ',
          field: ''
        },
        {
          headerName: 'Tên',
          field: ''
        },
        {
          headerName: 'Ngày sinh nhật',
          field: ''
        },
        {
          headerName: 'Ngày đến',
          field: ''
        },
        {
          headerName: 'Ngày đi',
          field: ''
        },
        {
          headerName: 'Công ty',
          field: ''
        }
      ]
    }
  },

  mounted() {
    this.fnGetBirthDay()
  },

  methods: {
    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetListAgent()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetListAgent()
    },

    // handle api call
    fnGetBirthDay() {
      getBirthDay(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            message: 'Lỗi lấy dữ liệu!',
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>
